import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthenticatedUser } from "../hooks/useAuthenticatedUser";

export const AdminProtected: React.FC = () => {
  const { isAdmin } = useAuthenticatedUser();

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

